import { render, staticRenderFns } from "./StartWhiteLabel.vue?vue&type=template&id=86245d72&scoped=true"
import script from "./StartWhiteLabel.vue?vue&type=script&lang=js"
export * from "./StartWhiteLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86245d72",
  null
  
)

export default component.exports